/**
 * Airport Timezone Utilities
 * Maps ICAO codes to IANA timezones for date formatting
 */

// Common airports with their IANA timezones
const AIRPORT_TIMEZONES = {
  // ============================================
  // UNITED STATES (K prefix) - Multiple timezones
  // ============================================

  // United States - Eastern (UTC-5/-4 DST)
  'KJFK': 'America/New_York',
  'KLGA': 'America/New_York',
  'KEWR': 'America/New_York',
  'KBOS': 'America/New_York',
  'KPHL': 'America/New_York',
  'KDCA': 'America/New_York',
  'KIAD': 'America/New_York',
  'KBWI': 'America/New_York',
  'KMIA': 'America/New_York',
  'KFLL': 'America/New_York',
  'KMCO': 'America/New_York',
  'KTPA': 'America/New_York',
  'KATL': 'America/New_York',
  'KCLT': 'America/New_York',
  'KRDU': 'America/New_York',
  'KPBI': 'America/New_York',
  'KTEB': 'America/New_York',
  'KHPN': 'America/New_York',
  'KBED': 'America/New_York',
  'KFXE': 'America/New_York',
  'KPDK': 'America/New_York',
  'KPWM': 'America/New_York',
  'KBDL': 'America/New_York',
  'KPIT': 'America/New_York',
  'KCLE': 'America/New_York',
  'KCMH': 'America/New_York',
  'KIND': 'America/New_York',
  'KDTW': 'America/New_York',
  'KBUF': 'America/New_York',
  'KSYR': 'America/New_York',
  'KALB': 'America/New_York',
  'KRIC': 'America/New_York',
  'KORF': 'America/New_York',
  'KJAX': 'America/New_York',
  'KSAV': 'America/New_York',
  'KCHS': 'America/New_York',
  'KGSP': 'America/New_York',
  'KAVL': 'America/New_York',

  // United States - Central (UTC-6/-5 DST)
  'KORD': 'America/Chicago',
  'KMDW': 'America/Chicago',
  'KDFW': 'America/Chicago',
  'KHOU': 'America/Chicago',
  'KIAH': 'America/Chicago',
  'KAUS': 'America/Chicago',
  'KSAT': 'America/Chicago',
  'KMSY': 'America/Chicago',
  'KMSP': 'America/Chicago',
  'KMCI': 'America/Chicago',
  'KSTL': 'America/Chicago',
  'KMEM': 'America/Chicago',
  'KBNA': 'America/Chicago',
  'KPWK': 'America/Chicago',
  'KADS': 'America/Chicago',
  'KDAL': 'America/Chicago',
  'KMKE': 'America/Chicago',
  'KOMA': 'America/Chicago',
  'KOKC': 'America/Chicago',
  'KTUL': 'America/Chicago',
  'KLIT': 'America/Chicago',
  'KJAN': 'America/Chicago',
  'KBHM': 'America/Chicago',
  'KHSV': 'America/Chicago',
  'KMOB': 'America/Chicago',
  'KSHV': 'America/Chicago',
  'KDSM': 'America/Chicago',
  'KFSD': 'America/Chicago',
  'KICT': 'America/Chicago',

  // United States - Mountain (UTC-7/-6 DST)
  'KDEN': 'America/Denver',
  'KSLC': 'America/Denver',
  'KABQ': 'America/Denver',
  'KAPA': 'America/Denver',
  'KCOS': 'America/Denver',
  'KASE': 'America/Denver',
  'KEGE': 'America/Denver',
  'KGJT': 'America/Denver',
  'KBOI': 'America/Denver',
  'KBIL': 'America/Denver',
  'KGEG': 'America/Denver',
  'KMSO': 'America/Denver',
  'KCYS': 'America/Denver',
  'KRIW': 'America/Denver',
  'KRAP': 'America/Denver',
  'KFAR': 'America/Chicago', // North Dakota is Central
  'KBIS': 'America/Chicago', // North Dakota is Central

  // United States - Arizona (No DST, UTC-7 year round)
  'KPHX': 'America/Phoenix',
  'KSDL': 'America/Phoenix',
  'KTUS': 'America/Phoenix',
  'KFLG': 'America/Phoenix',
  'KPRC': 'America/Phoenix',

  // United States - Pacific (UTC-8/-7 DST)
  'KLAX': 'America/Los_Angeles',
  'KSFO': 'America/Los_Angeles',
  'KSAN': 'America/Los_Angeles',
  'KSJC': 'America/Los_Angeles',
  'KOAK': 'America/Los_Angeles',
  'KSEA': 'America/Los_Angeles',
  'KPDX': 'America/Los_Angeles',
  'KLAS': 'America/Los_Angeles',
  'KVNY': 'America/Los_Angeles',
  'KSMO': 'America/Los_Angeles',
  'KBUR': 'America/Los_Angeles',
  'KLGB': 'America/Los_Angeles',
  'KONT': 'America/Los_Angeles',
  'KPSP': 'America/Los_Angeles',
  'KSMF': 'America/Los_Angeles',
  'KFAT': 'America/Los_Angeles',
  'KRNO': 'America/Los_Angeles',
  'KSNA': 'America/Los_Angeles',
  'KCMA': 'America/Los_Angeles',
  'KMRY': 'America/Los_Angeles',
  'KSBP': 'America/Los_Angeles',

  // ============================================
  // PACIFIC ISLANDS (P prefix) - Multiple timezones!
  // ============================================

  // Alaska (UTC-9/-8 DST)
  'PANC': 'America/Anchorage',
  'PAFA': 'America/Anchorage',
  'PAJN': 'America/Anchorage',
  'PAKN': 'America/Anchorage',
  'PAOM': 'America/Nome',
  'PADQ': 'America/Anchorage',

  // Hawaii (UTC-10, no DST)
  'PHNL': 'Pacific/Honolulu',
  'PHOG': 'Pacific/Honolulu',
  'PHKO': 'Pacific/Honolulu',
  'PHLI': 'Pacific/Honolulu',
  'PHTO': 'Pacific/Honolulu',

  // Guam (UTC+10)
  'PGUM': 'Pacific/Guam',
  'PGUA': 'Pacific/Guam',

  // Saipan/Northern Mariana Islands (UTC+10)
  'PGSN': 'Pacific/Guam',

  // Marshall Islands (UTC+12)
  'PKWA': 'Pacific/Majuro',
  'PKMJ': 'Pacific/Majuro',

  // Palau (UTC+9)
  'PTRO': 'Pacific/Palau',

  // Micronesia
  'PTPN': 'Pacific/Pohnpei',
  'PTKK': 'Pacific/Chuuk',

  // American Samoa (UTC-11)
  'NSTU': 'Pacific/Pago_Pago',

  // Midway (UTC-11)
  'PMDY': 'Pacific/Midway',

  // Wake Island (UTC+12)
  'PWAK': 'Pacific/Wake',

  // ============================================
  // CANADA (C prefix) - 6 timezones
  // ============================================

  // Canada - Eastern (UTC-5/-4 DST)
  'CYYZ': 'America/Toronto',
  'CYUL': 'America/Montreal',
  'CYOW': 'America/Toronto',
  'CYQB': 'America/Toronto',
  'CYHZ': 'America/Halifax',
  'CYSJ': 'America/Halifax',
  'CYFC': 'America/Halifax',
  'CYQM': 'America/Halifax',
  'CYYT': 'America/St_Johns',
  'CYDF': 'America/St_Johns',

  // Canada - Central (UTC-6/-5 DST)
  'CYWG': 'America/Winnipeg',
  'CYQR': 'America/Regina',
  'CYXE': 'America/Regina',

  // Canada - Mountain (UTC-7/-6 DST)
  'CYYC': 'America/Edmonton',
  'CYEG': 'America/Edmonton',

  // Canada - Pacific (UTC-8/-7 DST)
  'CYVR': 'America/Vancouver',
  'CYYJ': 'America/Vancouver',
  'CYLW': 'America/Vancouver',

  // ============================================
  // R PREFIX - Japan, Korea, Philippines, Taiwan (DIFFERENT TIMEZONES!)
  // ============================================

  // Japan (UTC+9)
  'RJTT': 'Asia/Tokyo',
  'RJAA': 'Asia/Tokyo',
  'RJBB': 'Asia/Tokyo',
  'RJCC': 'Asia/Tokyo',
  'RJGG': 'Asia/Tokyo',
  'RJFF': 'Asia/Tokyo',
  'RJOO': 'Asia/Tokyo',
  'RJSS': 'Asia/Tokyo',
  'RJSN': 'Asia/Tokyo',
  'ROAH': 'Asia/Tokyo', // Okinawa

  // South Korea (UTC+9)
  'RKSI': 'Asia/Seoul',
  'RKSS': 'Asia/Seoul',
  'RKPK': 'Asia/Seoul',
  'RKPC': 'Asia/Seoul',
  'RKTN': 'Asia/Seoul',
  'RKJJ': 'Asia/Seoul',

  // Philippines (UTC+8) - DIFFERENT from Japan/Korea!
  'RPLL': 'Asia/Manila',
  'RPLC': 'Asia/Manila',
  'RPVM': 'Asia/Manila',
  'RPVD': 'Asia/Manila',
  'RPVI': 'Asia/Manila',
  'RPVP': 'Asia/Manila',
  'RPVK': 'Asia/Manila',
  'RPWS': 'Asia/Manila',
  'RPMD': 'Asia/Manila',
  'RPMR': 'Asia/Manila',
  'RPMP': 'Asia/Manila',
  'RPMZ': 'Asia/Manila',
  'RPVB': 'Asia/Manila',
  'RPVA': 'Asia/Manila',
  'RPVS': 'Asia/Manila',
  'RPLB': 'Asia/Manila',
  'RPLS': 'Asia/Manila',
  'RPUO': 'Asia/Manila',
  'RPUS': 'Asia/Manila',
  'RPUN': 'Asia/Manila',
  'RPUQ': 'Asia/Manila',
  'RPUP': 'Asia/Manila',
  'RPUH': 'Asia/Manila',
  'RPUV': 'Asia/Manila',
  'RPUW': 'Asia/Manila',
  'RPUB': 'Asia/Manila',
  'RPUD': 'Asia/Manila',
  'RPUI': 'Asia/Manila',
  'RPUL': 'Asia/Manila',
  'RPUM': 'Asia/Manila',
  'RPUZ': 'Asia/Manila',
  'RPVF': 'Asia/Manila',
  'RPVG': 'Asia/Manila',
  'RPVJ': 'Asia/Manila',
  'RPVO': 'Asia/Manila',
  'RPVQ': 'Asia/Manila',
  'RPVR': 'Asia/Manila',
  'RPVT': 'Asia/Manila',
  'RPVY': 'Asia/Manila',

  // Taiwan (UTC+8) - DIFFERENT from Japan/Korea!
  'RCTP': 'Asia/Taipei',
  'RCSS': 'Asia/Taipei',
  'RCKH': 'Asia/Taipei',
  'RCMQ': 'Asia/Taipei',
  'RCNN': 'Asia/Taipei',
  'RCLG': 'Asia/Taipei',
  'RCFN': 'Asia/Taipei',
  'RCYU': 'Asia/Taipei',
  'RCQC': 'Asia/Taipei',
  'RCKU': 'Asia/Taipei',
  'RCBS': 'Asia/Taipei',
  'RCMT': 'Asia/Taipei',

  // ============================================
  // V PREFIX - South/Southeast Asia (MANY DIFFERENT TIMEZONES!)
  // ============================================

  // Hong Kong (UTC+8)
  'VHHH': 'Asia/Hong_Kong',

  // Macau (UTC+8)
  'VMMC': 'Asia/Macau',

  // Thailand (UTC+7)
  'VTBS': 'Asia/Bangkok',
  'VTBD': 'Asia/Bangkok',
  'VTSP': 'Asia/Bangkok',
  'VTSS': 'Asia/Bangkok',
  'VTCC': 'Asia/Bangkok',
  'VTUD': 'Asia/Bangkok',
  'VTUK': 'Asia/Bangkok',
  'VTUN': 'Asia/Bangkok',

  // Vietnam (UTC+7)
  'VVNB': 'Asia/Ho_Chi_Minh',
  'VVTS': 'Asia/Ho_Chi_Minh',
  'VVDN': 'Asia/Ho_Chi_Minh',
  'VVCR': 'Asia/Ho_Chi_Minh',
  'VVPQ': 'Asia/Ho_Chi_Minh',
  'VVCI': 'Asia/Ho_Chi_Minh',

  // India (UTC+5:30)
  'VIDP': 'Asia/Kolkata',
  'VABB': 'Asia/Kolkata',
  'VOBL': 'Asia/Kolkata',
  'VOMM': 'Asia/Kolkata',
  'VOHS': 'Asia/Kolkata',
  'VOCL': 'Asia/Kolkata',
  'VOCI': 'Asia/Kolkata',
  'VAAH': 'Asia/Kolkata',
  'VECC': 'Asia/Kolkata',
  'VEPY': 'Asia/Kolkata',
  'VIJP': 'Asia/Kolkata',
  'VIAR': 'Asia/Kolkata',
  'VOTR': 'Asia/Kolkata',
  'VAGO': 'Asia/Kolkata',
  'VASU': 'Asia/Kolkata',
  'VAID': 'Asia/Kolkata',
  'VILK': 'Asia/Kolkata',
  'VIBN': 'Asia/Kolkata',

  // Nepal (UTC+5:45)
  'VNKT': 'Asia/Kathmandu',
  'VNPK': 'Asia/Kathmandu',
  'VNBW': 'Asia/Kathmandu',

  // Bangladesh (UTC+6)
  'VGHS': 'Asia/Dhaka',
  'VGCG': 'Asia/Dhaka',
  'VGSY': 'Asia/Dhaka',

  // Sri Lanka (UTC+5:30)
  'VCBI': 'Asia/Colombo',
  'VCRI': 'Asia/Colombo',

  // Maldives (UTC+5)
  'VRMM': 'Indian/Maldives',
  'VRMV': 'Indian/Maldives',
  'VRMD': 'Indian/Maldives',

  // Myanmar (UTC+6:30)
  'VYYY': 'Asia/Yangon',
  'VYBG': 'Asia/Yangon',
  'VYMD': 'Asia/Yangon',

  // Cambodia (UTC+7)
  'VDPP': 'Asia/Phnom_Penh',
  'VDSR': 'Asia/Phnom_Penh',

  // Laos (UTC+7)
  'VLVT': 'Asia/Vientiane',
  'VLLB': 'Asia/Vientiane',

  // Pakistan (UTC+5)
  'OPKC': 'Asia/Karachi',
  'OPLA': 'Asia/Karachi',
  'OPIS': 'Asia/Karachi',
  'OPRN': 'Asia/Karachi',
  'OPPS': 'Asia/Karachi',
  'OPFA': 'Asia/Karachi',
  'OPQT': 'Asia/Karachi',
  'OPSB': 'Asia/Karachi',
  'OPMT': 'Asia/Karachi',

  // ============================================
  // W PREFIX - Indonesia/Malaysia/Singapore (DIFFERENT TIMEZONES!)
  // ============================================

  // Singapore (UTC+8)
  'WSSS': 'Asia/Singapore',
  'WSSL': 'Asia/Singapore',

  // Malaysia - Peninsular (UTC+8)
  'WMKK': 'Asia/Kuala_Lumpur',
  'WMKP': 'Asia/Kuala_Lumpur',
  'WMKL': 'Asia/Kuala_Lumpur',
  'WMKJ': 'Asia/Kuala_Lumpur',
  'WMSA': 'Asia/Kuala_Lumpur',

  // Malaysia - Borneo (UTC+8)
  'WBKK': 'Asia/Kuching',
  'WBGG': 'Asia/Kuching',
  'WBKT': 'Asia/Kuching',

  // Brunei (UTC+8)
  'WBSB': 'Asia/Brunei',

  // Indonesia - Western (UTC+7)
  'WIII': 'Asia/Jakarta',
  'WIDD': 'Asia/Jakarta',
  'WIMM': 'Asia/Jakarta',
  'WIHH': 'Asia/Jakarta',
  'WIBB': 'Asia/Jakarta',
  'WIPK': 'Asia/Jakarta',
  'WICC': 'Asia/Jakarta',
  'WICA': 'Asia/Jakarta',
  'WICM': 'Asia/Jakarta',
  'WIDS': 'Asia/Jakarta',
  'WIIA': 'Asia/Jakarta',
  'WIIB': 'Asia/Jakarta',
  'WIIC': 'Asia/Jakarta',
  'WIIG': 'Asia/Jakarta',
  'WIIH': 'Asia/Jakarta',
  'WIIJ': 'Asia/Jakarta',
  'WIIK': 'Asia/Jakarta',
  'WIIL': 'Asia/Jakarta',
  'WIIM': 'Asia/Jakarta',
  'WIIN': 'Asia/Jakarta',
  'WIIO': 'Asia/Jakarta',
  'WIIP': 'Asia/Jakarta',
  'WIIS': 'Asia/Jakarta',
  'WIIT': 'Asia/Jakarta',

  // Indonesia - Central (UTC+8)
  'WAAA': 'Asia/Makassar',
  'WABB': 'Asia/Makassar',
  'WADD': 'Asia/Makassar', // Bali
  'WAMM': 'Asia/Makassar',
  'WALL': 'Asia/Makassar',
  'WAFF': 'Asia/Makassar',
  'WALR': 'Asia/Makassar',
  'WALS': 'Asia/Makassar',
  'WAMG': 'Asia/Makassar',
  'WAMI': 'Asia/Makassar',
  'WAMJ': 'Asia/Makassar',
  'WAMK': 'Asia/Makassar',
  'WAML': 'Asia/Makassar',
  'WAMP': 'Asia/Makassar',
  'WAMR': 'Asia/Makassar',
  'WAMS': 'Asia/Makassar',
  'WAMT': 'Asia/Makassar',
  'WAMW': 'Asia/Makassar',

  // Indonesia - Eastern (UTC+9)
  'WAJJ': 'Asia/Jayapura',
  'WAJW': 'Asia/Jayapura',
  'WAJI': 'Asia/Jayapura',
  'WAJB': 'Asia/Jayapura',
  'WAJE': 'Asia/Jayapura',
  'WAJM': 'Asia/Jayapura',
  'WAJS': 'Asia/Jayapura',
  'WASK': 'Asia/Jayapura',
  'WASF': 'Asia/Jayapura',
  'WASO': 'Asia/Jayapura',
  'WASR': 'Asia/Jayapura',
  'WASS': 'Asia/Jayapura',

  // ============================================
  // O PREFIX - Middle East (MANY DIFFERENT TIMEZONES!)
  // ============================================

  // UAE (UTC+4)
  'OMDB': 'Asia/Dubai',
  'OMSJ': 'Asia/Dubai',
  'OMAA': 'Asia/Dubai',
  'OMAD': 'Asia/Dubai',
  'OMAL': 'Asia/Dubai',
  'OMRK': 'Asia/Dubai',
  'OMFJ': 'Asia/Dubai',

  // Oman (UTC+4)
  'OOMS': 'Asia/Muscat',
  'OOSA': 'Asia/Muscat',
  'OOKB': 'Asia/Muscat',

  // Qatar (UTC+3)
  'OTHH': 'Asia/Qatar',
  'OTBH': 'Asia/Qatar',

  // Bahrain (UTC+3)
  'OBBI': 'Asia/Bahrain',

  // Kuwait (UTC+3)
  'OKBK': 'Asia/Kuwait',

  // Saudi Arabia (UTC+3)
  'OEJN': 'Asia/Riyadh',
  'OERK': 'Asia/Riyadh',
  'OEDF': 'Asia/Riyadh',
  'OEMA': 'Asia/Riyadh',
  'OEDM': 'Asia/Riyadh',
  'OEAB': 'Asia/Riyadh',
  'OEGN': 'Asia/Riyadh',
  'OESH': 'Asia/Riyadh',
  'OETB': 'Asia/Riyadh',
  'OETF': 'Asia/Riyadh',
  'OEGS': 'Asia/Riyadh',
  'OEKJ': 'Asia/Riyadh',
  'OEYN': 'Asia/Riyadh',

  // Iraq (UTC+3)
  'ORBI': 'Asia/Baghdad',
  'ORMM': 'Asia/Baghdad',
  'ORER': 'Asia/Baghdad',
  'ORNI': 'Asia/Baghdad',
  'ORSU': 'Asia/Baghdad',

  // Jordan (UTC+3)
  'OJAI': 'Asia/Amman',
  'OJAQ': 'Asia/Amman',
  'OJMF': 'Asia/Amman',

  // Lebanon (UTC+2)
  'OLBA': 'Asia/Beirut',

  // Syria (UTC+3)
  'OSDI': 'Asia/Damascus',
  'OSAP': 'Asia/Damascus',
  'OSLK': 'Asia/Damascus',

  // Israel (UTC+2)
  'LLBG': 'Asia/Jerusalem',
  'LLSD': 'Asia/Jerusalem',
  'LLET': 'Asia/Jerusalem',
  'LLIB': 'Asia/Jerusalem',
  'LLHA': 'Asia/Jerusalem',

  // Iran (UTC+3:30)
  'OIIE': 'Asia/Tehran',
  'OIII': 'Asia/Tehran',
  'OIKK': 'Asia/Tehran',
  'OISS': 'Asia/Tehran',
  'OIZH': 'Asia/Tehran',
  'OIMM': 'Asia/Tehran',
  'OIBB': 'Asia/Tehran',

  // Afghanistan (UTC+4:30)
  'OAKB': 'Asia/Kabul',
  'OAIX': 'Asia/Kabul',
  'OAHR': 'Asia/Kabul',
  'OAKN': 'Asia/Kabul',
  'OAMS': 'Asia/Kabul',

  // Yemen (UTC+3)
  'OYAA': 'Asia/Aden',
  'OYSN': 'Asia/Aden',

  // ============================================
  // E PREFIX - Northern Europe (DIFFERENT TIMEZONES!)
  // ============================================

  // United Kingdom & Ireland (UTC+0/+1 DST)
  'EGLL': 'Europe/London',
  'EGLF': 'Europe/London',
  'EGKK': 'Europe/London',
  'EGGW': 'Europe/London',
  'EGSS': 'Europe/London',
  'EGGD': 'Europe/London',
  'EGCC': 'Europe/London',
  'EGBB': 'Europe/London',
  'EGPH': 'Europe/London',
  'EGPF': 'Europe/London',
  'EGPD': 'Europe/London',
  'EGPK': 'Europe/London',
  'EGAC': 'Europe/London',
  'EGAA': 'Europe/London',
  'EGNS': 'Europe/London',
  'EGJJ': 'Europe/London',
  'EGJB': 'Europe/London',
  'EIDW': 'Europe/Dublin',
  'EICK': 'Europe/Dublin',
  'EINN': 'Europe/Dublin',
  'EIKN': 'Europe/Dublin',

  // Germany (UTC+1/+2 DST)
  'EDDF': 'Europe/Berlin',
  'EDDM': 'Europe/Berlin',
  'EDDB': 'Europe/Berlin',
  'EDDL': 'Europe/Berlin',
  'EDDH': 'Europe/Berlin',
  'EDDK': 'Europe/Berlin',
  'EDDS': 'Europe/Berlin',
  'EDDW': 'Europe/Berlin',
  'EDDN': 'Europe/Berlin',
  'EDDP': 'Europe/Berlin',
  'EDDC': 'Europe/Berlin',
  'EDDT': 'Europe/Berlin',

  // France (UTC+1/+2 DST)
  'LFPG': 'Europe/Paris',
  'LFPO': 'Europe/Paris',
  'LFPB': 'Europe/Paris',
  'LFMN': 'Europe/Paris',
  'LFML': 'Europe/Paris',
  'LFLL': 'Europe/Paris',
  'LFBD': 'Europe/Paris',
  'LFBO': 'Europe/Paris',
  'LFSB': 'Europe/Paris',
  'LFRS': 'Europe/Paris',
  'LFRB': 'Europe/Paris',
  'LFRN': 'Europe/Paris',
  'LFST': 'Europe/Paris',

  // Netherlands (UTC+1/+2 DST)
  'EHAM': 'Europe/Amsterdam',
  'EHRD': 'Europe/Amsterdam',
  'EHEH': 'Europe/Amsterdam',

  // Belgium (UTC+1/+2 DST)
  'EBBR': 'Europe/Brussels',
  'EBCI': 'Europe/Brussels',
  'EBAW': 'Europe/Brussels',
  'EBLG': 'Europe/Brussels',

  // Austria (UTC+1/+2 DST)
  'LOWW': 'Europe/Vienna',
  'LOWS': 'Europe/Vienna',
  'LOWI': 'Europe/Vienna',
  'LOWG': 'Europe/Vienna',
  'LOWL': 'Europe/Vienna',
  'LOWK': 'Europe/Vienna',

  // Poland (UTC+1/+2 DST)
  'EPWA': 'Europe/Warsaw',
  'EPKK': 'Europe/Warsaw',
  'EPGD': 'Europe/Warsaw',
  'EPWR': 'Europe/Warsaw',
  'EPPO': 'Europe/Warsaw',
  'EPKT': 'Europe/Warsaw',

  // Czechia (UTC+1/+2 DST)
  'LKPR': 'Europe/Prague',
  'LKTB': 'Europe/Prague',
  'LKMT': 'Europe/Prague',

  // Sweden (UTC+1/+2 DST)
  'ESSA': 'Europe/Stockholm',
  'ESGG': 'Europe/Stockholm',
  'ESMS': 'Europe/Stockholm',

  // Norway (UTC+1/+2 DST)
  'ENGM': 'Europe/Oslo',
  'ENBR': 'Europe/Oslo',
  'ENZV': 'Europe/Oslo',
  'ENVA': 'Europe/Oslo',

  // Denmark (UTC+1/+2 DST)
  'EKCH': 'Europe/Copenhagen',
  'EKBI': 'Europe/Copenhagen',
  'EKAH': 'Europe/Copenhagen',

  // Finland (UTC+2/+3 DST) - DIFFERENT!
  'EFHK': 'Europe/Helsinki',
  'EFTP': 'Europe/Helsinki',
  'EFOU': 'Europe/Helsinki',
  'EFTU': 'Europe/Helsinki',
  'EFRO': 'Europe/Helsinki',

  // Estonia (UTC+2/+3 DST) - DIFFERENT!
  'EETN': 'Europe/Tallinn',
  'EETU': 'Europe/Tallinn',

  // Latvia (UTC+2/+3 DST) - DIFFERENT!
  'EVRA': 'Europe/Riga',

  // Lithuania (UTC+2/+3 DST) - DIFFERENT!
  'EYVI': 'Europe/Vilnius',
  'EYKA': 'Europe/Vilnius',

  // Iceland (UTC+0, no DST)
  'BIKF': 'Atlantic/Reykjavik',
  'BIRK': 'Atlantic/Reykjavik',

  // ============================================
  // L PREFIX - Southern Europe (DIFFERENT TIMEZONES!)
  // ============================================

  // Switzerland (UTC+1/+2 DST)
  'LSZH': 'Europe/Zurich',
  'LSGG': 'Europe/Zurich',
  'LSZA': 'Europe/Zurich',
  'LSZB': 'Europe/Zurich',

  // Italy (UTC+1/+2 DST)
  'LIRF': 'Europe/Rome',
  'LIMC': 'Europe/Rome',
  'LIPZ': 'Europe/Rome',
  'LIPE': 'Europe/Rome',
  'LIML': 'Europe/Rome',
  'LIMF': 'Europe/Rome',
  'LIRN': 'Europe/Rome',
  'LICC': 'Europe/Rome',
  'LICJ': 'Europe/Rome',
  'LIEA': 'Europe/Rome',
  'LIEE': 'Europe/Rome',
  'LIRA': 'Europe/Rome',
  'LIRP': 'Europe/Rome',
  'LIRQ': 'Europe/Rome',

  // Spain (UTC+1/+2 DST)
  'LEMD': 'Europe/Madrid',
  'LEBL': 'Europe/Madrid',
  'LEAL': 'Europe/Madrid',
  'LEPA': 'Europe/Madrid',
  'LEMG': 'Europe/Madrid',
  'LEZL': 'Europe/Madrid',
  'LEVC': 'Europe/Madrid',
  'LEBB': 'Europe/Madrid',
  'LEST': 'Europe/Madrid',
  'LEXJ': 'Europe/Madrid',
  'LECO': 'Europe/Madrid',
  'LERS': 'Europe/Madrid',
  'LEGE': 'Europe/Madrid',
  'LEGR': 'Europe/Madrid',
  'LEIB': 'Europe/Madrid',
  'LEMH': 'Europe/Madrid',

  // Canary Islands (UTC+0/+1 DST) - DIFFERENT from mainland Spain!
  'GCTS': 'Atlantic/Canary',
  'GCLP': 'Atlantic/Canary',
  'GCFV': 'Atlantic/Canary',
  'GCLA': 'Atlantic/Canary',
  'GCRR': 'Atlantic/Canary',
  'GCXO': 'Atlantic/Canary',
  'GCHI': 'Atlantic/Canary',

  // Portugal (UTC+0/+1 DST) - DIFFERENT from Spain!
  'LPPT': 'Europe/Lisbon',
  'LPPR': 'Europe/Lisbon',
  'LPFR': 'Europe/Lisbon',
  'LPMA': 'Atlantic/Madeira',
  'LPPS': 'Atlantic/Madeira',
  'LPAZ': 'Atlantic/Azores',
  'LPPD': 'Atlantic/Azores',

  // Greece (UTC+2/+3 DST) - DIFFERENT!
  'LGAV': 'Europe/Athens',
  'LGTS': 'Europe/Athens',
  'LGSA': 'Europe/Athens',
  'LGIR': 'Europe/Athens',
  'LGKR': 'Europe/Athens',
  'LGKF': 'Europe/Athens',
  'LGKO': 'Europe/Athens',
  'LGMK': 'Europe/Athens',
  'LGSR': 'Europe/Athens',
  'LGZA': 'Europe/Athens',
  'LGRP': 'Europe/Athens',

  // Turkey (UTC+3, no DST) - DIFFERENT!
  'LTFM': 'Europe/Istanbul',
  'LTBA': 'Europe/Istanbul',
  'LTAI': 'Europe/Istanbul',
  'LTBS': 'Europe/Istanbul',
  'LTFE': 'Europe/Istanbul',
  'LTBJ': 'Europe/Istanbul',
  'LTAC': 'Europe/Istanbul',
  'LTAF': 'Europe/Istanbul',
  'LTCG': 'Europe/Istanbul',
  'LTCE': 'Europe/Istanbul',
  'LTAU': 'Europe/Istanbul',
  'LTFJ': 'Europe/Istanbul',

  // Cyprus (UTC+2/+3 DST)
  'LCLK': 'Asia/Nicosia',
  'LCPH': 'Asia/Nicosia',

  // Romania (UTC+2/+3 DST)
  'LROP': 'Europe/Bucharest',
  'LRBS': 'Europe/Bucharest',
  'LRCL': 'Europe/Bucharest',
  'LRTM': 'Europe/Bucharest',

  // Bulgaria (UTC+2/+3 DST)
  'LBSF': 'Europe/Sofia',
  'LBBG': 'Europe/Sofia',
  'LBWN': 'Europe/Sofia',

  // Hungary (UTC+1/+2 DST)
  'LHBP': 'Europe/Budapest',

  // Croatia (UTC+1/+2 DST)
  'LDZA': 'Europe/Zagreb',
  'LDSP': 'Europe/Zagreb',
  'LDDU': 'Europe/Zagreb',

  // Serbia (UTC+1/+2 DST)
  'LYBE': 'Europe/Belgrade',

  // Slovenia (UTC+1/+2 DST)
  'LJLJ': 'Europe/Ljubljana',

  // Malta (UTC+1/+2 DST)
  'LMML': 'Europe/Malta',

  // Monaco (UTC+1/+2 DST)
  'LNMC': 'Europe/Monaco',

  // ============================================
  // S PREFIX - South America (MANY DIFFERENT TIMEZONES!)
  // ============================================

  // Brazil - Brasilia Time (UTC-3)
  'SBGR': 'America/Sao_Paulo',
  'SBRJ': 'America/Sao_Paulo',
  'SBSP': 'America/Sao_Paulo',
  'SBKP': 'America/Sao_Paulo',
  'SBBR': 'America/Sao_Paulo',
  'SBCF': 'America/Sao_Paulo',
  'SBGL': 'America/Sao_Paulo',
  'SBPA': 'America/Sao_Paulo',
  'SBCT': 'America/Sao_Paulo',
  'SBFL': 'America/Sao_Paulo',
  'SBSV': 'America/Sao_Paulo',
  'SBRF': 'America/Sao_Paulo',
  'SBFZ': 'America/Sao_Paulo',
  'SBNT': 'America/Sao_Paulo',
  'SBBE': 'America/Sao_Paulo',

  // Brazil - Amazon Time (UTC-4)
  'SBMN': 'America/Manaus',
  'SBEG': 'America/Manaus',
  'SBPV': 'America/Manaus',
  'SBCZ': 'America/Manaus',
  'SBTF': 'America/Manaus',

  // Brazil - Acre Time (UTC-5)
  'SBRB': 'America/Rio_Branco',

  // Argentina (UTC-3)
  'SAEZ': 'America/Buenos_Aires',
  'SABE': 'America/Buenos_Aires',
  'SACO': 'America/Buenos_Aires',
  'SAAR': 'America/Buenos_Aires',
  'SAME': 'America/Buenos_Aires',
  'SANC': 'America/Buenos_Aires',
  'SANU': 'America/Buenos_Aires',
  'SAWH': 'America/Buenos_Aires',
  'SAWC': 'America/Buenos_Aires',
  'SAVC': 'America/Buenos_Aires',

  // Chile (UTC-4/-3 DST) - DIFFERENT from Argentina!
  'SCEL': 'America/Santiago',
  'SCIE': 'America/Santiago',
  'SCFA': 'America/Santiago',
  'SCTE': 'America/Santiago',
  'SCAT': 'America/Santiago',
  'SCIP': 'Pacific/Easter', // Easter Island (UTC-6/-5 DST)

  // Colombia (UTC-5) - DIFFERENT!
  'SKBO': 'America/Bogota',
  'SKRG': 'America/Bogota',
  'SKCL': 'America/Bogota',
  'SKBQ': 'America/Bogota',
  'SKCG': 'America/Bogota',
  'SKMD': 'America/Bogota',
  'SKMR': 'America/Bogota',
  'SKPE': 'America/Bogota',
  'SKSP': 'America/Bogota',
  'SKSM': 'America/Bogota',
  'SKUC': 'America/Bogota',

  // Peru (UTC-5) - DIFFERENT!
  'SPJC': 'America/Lima',
  'SPZO': 'America/Lima',
  'SPQU': 'America/Lima',
  'SPHY': 'America/Lima',
  'SPIM': 'America/Lima',

  // Ecuador (UTC-5) - DIFFERENT!
  'SEQM': 'America/Guayaquil',
  'SEGU': 'America/Guayaquil',
  'SECO': 'America/Guayaquil',
  'SEGS': 'Pacific/Galapagos', // Galapagos (UTC-6)

  // Bolivia (UTC-4)
  'SLLP': 'America/La_Paz',
  'SLVR': 'America/La_Paz',
  'SLCB': 'America/La_Paz',
  'SLSU': 'America/La_Paz',

  // Paraguay (UTC-4/-3 DST)
  'SGAS': 'America/Asuncion',

  // Uruguay (UTC-3)
  'SUMU': 'America/Montevideo',
  'SUPU': 'America/Montevideo',

  // Venezuela (UTC-4)
  'SVMI': 'America/Caracas',
  'SVMC': 'America/Caracas',
  'SVVA': 'America/Caracas',
  'SVBS': 'America/Caracas',

  // Guyana (UTC-4)
  'SYCJ': 'America/Guyana',

  // Suriname (UTC-3)
  'SMJP': 'America/Paramaribo',

  // French Guiana (UTC-3)
  'SOCA': 'America/Cayenne',

  // ============================================
  // CHINA (Z prefix) - Single timezone UTC+8
  // ============================================
  'ZBAA': 'Asia/Shanghai',
  'ZSPD': 'Asia/Shanghai',
  'ZGGG': 'Asia/Shanghai',
  'ZUUU': 'Asia/Shanghai',
  'ZGSZ': 'Asia/Shanghai',
  'ZSSS': 'Asia/Shanghai',
  'ZSHC': 'Asia/Shanghai',
  'ZHCC': 'Asia/Shanghai',
  'ZLXY': 'Asia/Shanghai',
  'ZSNJ': 'Asia/Shanghai',
  'ZSAM': 'Asia/Shanghai',
  'ZYTL': 'Asia/Shanghai',
  'ZYHB': 'Asia/Shanghai',
  'ZSOF': 'Asia/Shanghai',
  'ZGHA': 'Asia/Shanghai',
  'ZUCK': 'Asia/Shanghai',
  'ZPPP': 'Asia/Shanghai',
  'ZWWW': 'Asia/Shanghai',
  'ZLLL': 'Asia/Shanghai',
  'ZSNB': 'Asia/Shanghai',
  'ZSFZ': 'Asia/Shanghai',
  'ZSQD': 'Asia/Shanghai',
  'ZBTJ': 'Asia/Shanghai',
  'ZBSJ': 'Asia/Shanghai',
  'ZSJN': 'Asia/Shanghai',
  'ZSWY': 'Asia/Shanghai',

  // ============================================
  // AUSTRALIA (Y prefix) - Multiple timezones
  // ============================================

  // Eastern Australia (UTC+10/+11 DST)
  'YSSY': 'Australia/Sydney',
  'YMML': 'Australia/Melbourne',
  'YBBN': 'Australia/Brisbane',
  'YBCS': 'Australia/Brisbane',
  'YBCG': 'Australia/Brisbane',
  'YMHB': 'Australia/Hobart',
  'YSCB': 'Australia/Sydney',
  'YSNF': 'Australia/Sydney',

  // Central Australia (UTC+9:30/+10:30 DST)
  'YPAD': 'Australia/Adelaide',
  'YPDN': 'Australia/Darwin', // No DST

  // Western Australia (UTC+8, no DST)
  'YPPH': 'Australia/Perth',
  'YPKG': 'Australia/Perth',

  // ============================================
  // NEW ZEALAND & PACIFIC (N prefix)
  // ============================================

  // New Zealand (UTC+12/+13 DST)
  'NZAA': 'Pacific/Auckland',
  'NZWN': 'Pacific/Auckland',
  'NZCH': 'Pacific/Auckland',
  'NZQN': 'Pacific/Auckland',
  'NZDN': 'Pacific/Auckland',
  'NZPM': 'Pacific/Auckland',
  'NZNP': 'Pacific/Auckland',
  'NZRO': 'Pacific/Auckland',
  'NZHN': 'Pacific/Auckland',
  'NZTG': 'Pacific/Auckland',

  // Fiji (UTC+12/+13 DST)
  'NFFN': 'Pacific/Fiji',
  'NFNA': 'Pacific/Fiji',

  // Samoa (UTC+13/+14 DST)
  'NSFA': 'Pacific/Apia',

  // Tonga (UTC+13)
  'NFTF': 'Pacific/Tongatapu',

  // ============================================
  // MEXICO (M prefix)
  // ============================================
  'MMMX': 'America/Mexico_City',
  'MMUN': 'America/Cancun',
  'MMTJ': 'America/Tijuana',
  'MMGL': 'America/Mexico_City',
  'MMMY': 'America/Monterrey',
  'MMMD': 'America/Merida',
  'MMPR': 'America/Mexico_City',
  'MMSD': 'America/Mazatlan',
  'MMHO': 'America/Hermosillo',
  'MMCZ': 'America/Cancun',
  'MMCM': 'America/Merida',
  'MMCU': 'America/Chihuahua',
  'MMTO': 'America/Mexico_City',
  'MMLO': 'America/Mexico_City',
  'MMZC': 'America/Mexico_City',
  'MMPN': 'America/Mexico_City',
  'MMVR': 'America/Mexico_City',
  'MMSP': 'America/Mexico_City',
  'MMAA': 'America/Mexico_City',

  // ============================================
  // CARIBBEAN (T prefix)
  // ============================================
  'TNCM': 'America/Lower_Princes',
  'TBPB': 'America/Barbados',
  'TFFR': 'America/Guadeloupe',
  'MKJS': 'America/Jamaica',
  'TNCA': 'America/Aruba',
  'TTPP': 'America/Port_of_Spain',
  'TFFJ': 'America/St_Barthelemy',
  'TLPL': 'America/St_Lucia',
  'TAPA': 'America/Antigua',
  'TKPK': 'America/St_Kitts',
  'TDPD': 'America/Dominica',
  'TGPY': 'America/Grenada',
  'TVSC': 'America/St_Vincent',
  'TXKF': 'Atlantic/Bermuda',
  'MBPV': 'America/Nassau',
  'MYNN': 'America/Nassau',
  'MWCR': 'America/Cayman',
  'MWCB': 'America/Cayman',
  'MUHA': 'America/Havana',
  'MUVR': 'America/Havana',
  'MDPC': 'America/Santo_Domingo',
  'MDSD': 'America/Santo_Domingo',
  'MTPP': 'America/Port-au-Prince',
  'TJSJ': 'America/Puerto_Rico',
  'TIST': 'America/Virgin',
  'TISX': 'America/Virgin',

  // ============================================
  // RUSSIA (U prefix) - 11 timezones!
  // ============================================

  // Moscow Time (UTC+3)
  'UUEE': 'Europe/Moscow',
  'UUDD': 'Europe/Moscow',
  'UUWW': 'Europe/Moscow',
  'ULLI': 'Europe/Moscow',
  'UUOB': 'Europe/Moscow',
  'URSS': 'Europe/Moscow',
  'URKK': 'Europe/Moscow',
  'URRR': 'Europe/Moscow',
  'URWW': 'Europe/Moscow',
  'URMM': 'Europe/Moscow',
  'USSS': 'Asia/Yekaterinburg', // Yekaterinburg (UTC+5)
  'UNNT': 'Asia/Novosibirsk', // Novosibirsk (UTC+7)
  'UNKL': 'Asia/Krasnoyarsk', // Krasnoyarsk (UTC+7)
  'UIII': 'Asia/Irkutsk', // Irkutsk (UTC+8)
  'UHWW': 'Asia/Vladivostok', // Vladivostok (UTC+10)
  'UHSS': 'Asia/Sakhalin', // Sakhalin (UTC+11)
  'UHPP': 'Asia/Kamchatka', // Kamchatka (UTC+12)
  'UHMA': 'Asia/Magadan', // Magadan (UTC+11)
  'UHMM': 'Asia/Magadan',
  'UHMD': 'Asia/Anadyr', // Anadyr (UTC+12)

  // ============================================
  // AFRICA (Various prefixes)
  // ============================================

  // South Africa (UTC+2)
  'FAOR': 'Africa/Johannesburg',
  'FACT': 'Africa/Johannesburg',
  'FADN': 'Africa/Johannesburg',
  'FALE': 'Africa/Johannesburg',
  'FAPE': 'Africa/Johannesburg',
  'FALA': 'Africa/Johannesburg',

  // Egypt (UTC+2)
  'HECA': 'Africa/Cairo',
  'HEGN': 'Africa/Cairo',
  'HESH': 'Africa/Cairo',
  'HELX': 'Africa/Cairo',
  'HEMA': 'Africa/Cairo',
  'HESN': 'Africa/Cairo',

  // Morocco (UTC+1)
  'GMMN': 'Africa/Casablanca',
  'GMME': 'Africa/Casablanca',
  'GMFF': 'Africa/Casablanca',
  'GMAD': 'Africa/Casablanca',
  'GMTT': 'Africa/Casablanca',

  // Nigeria (UTC+1)
  'DNMM': 'Africa/Lagos',
  'DNAA': 'Africa/Lagos',
  'DNKN': 'Africa/Lagos',
  'DNPO': 'Africa/Lagos',

  // Kenya (UTC+3)
  'HKJK': 'Africa/Nairobi',
  'HKMO': 'Africa/Nairobi',

  // Ethiopia (UTC+3)
  'HAAB': 'Africa/Addis_Ababa',

  // Tanzania (UTC+3)
  'HTDA': 'Africa/Dar_es_Salaam',
  'HTZA': 'Africa/Dar_es_Salaam',
  'HTKJ': 'Africa/Dar_es_Salaam',

  // Ghana (UTC+0)
  'DGAA': 'Africa/Accra',

  // Senegal (UTC+0)
  'GOBD': 'Africa/Dakar',
  'GOOY': 'Africa/Dakar',

  // Ivory Coast (UTC+0)
  'DIAP': 'Africa/Abidjan',

  // Tunisia (UTC+1)
  'DTTA': 'Africa/Tunis',
  'DTMB': 'Africa/Tunis',

  // Algeria (UTC+1)
  'DAAG': 'Africa/Algiers',
  'DAOO': 'Africa/Algiers',

  // Libya (UTC+2)
  'HLLT': 'Africa/Tripoli',
  'HLLB': 'Africa/Tripoli',

  // Mauritius (UTC+4)
  'FIMP': 'Indian/Mauritius',

  // Seychelles (UTC+4)
  'FSIA': 'Indian/Mahe',

  // Madagascar (UTC+3)
  'FMMI': 'Indian/Antananarivo',
  'FMNN': 'Indian/Antananarivo',

  // Reunion (UTC+4)
  'FMEE': 'Indian/Reunion',
};

// Regional timezone fallbacks based on ICAO prefix
// NOTE: Many prefixes cover multiple timezones! These are last-resort fallbacks.
// Always add specific airports to AIRPORT_TIMEZONES for accuracy.
const REGIONAL_FALLBACKS = {
  // USA spans 6 timezones - Eastern is most common for private aviation
  'K': 'America/New_York',

  // Canada spans 6 timezones - Toronto covers Eastern Canada (most populated)
  'C': 'America/Toronto',

  // Northern Europe: UK (UTC+0), Central Europe (UTC+1), Baltics (UTC+2)
  // Most common destinations are Central Europe
  'E': 'Europe/Berlin',

  // Southern Europe: Portugal (UTC+0), Spain/Italy (UTC+1), Greece/Turkey (UTC+2/3)
  // Most destinations are UTC+1
  'L': 'Europe/Rome',

  // Russia spans 11 timezones! Moscow is most common
  'U': 'Europe/Moscow',

  // R prefix: Japan/Korea (UTC+9), Philippines/Taiwan (UTC+8)
  // Most destinations are Japan, but Philippines is significant - add airports explicitly!
  'R': 'Asia/Tokyo',

  // China uses single timezone (UTC+8)
  'Z': 'Asia/Shanghai',

  // V prefix covers: India (UTC+5:30), Thailand/Vietnam (UTC+7), HK/Macau (UTC+8)
  // Highly variable - add specific airports!
  'V': 'Asia/Bangkok',

  // W prefix: Indonesia (UTC+7/8/9), Malaysia/Singapore (UTC+8)
  // Singapore and Malaysia are common private jet destinations
  'W': 'Asia/Singapore',

  // Middle East: Pakistan (UTC+5), Iran (UTC+3:30), UAE/Oman (UTC+4), Saudi/Qatar (UTC+3)
  // UAE is common for private aviation
  'O': 'Asia/Dubai',

  // Africa spans multiple timezones (UTC-1 to UTC+4)
  // South Africa is common for business aviation
  'H': 'Africa/Johannesburg',

  // Australia: Western (UTC+8), Central (UTC+9:30), Eastern (UTC+10/11)
  // Eastern Australia is most populated
  'Y': 'Australia/Sydney',

  // New Zealand and Pacific islands
  'N': 'Pacific/Auckland',

  // South America: Brazil (UTC-3), Argentina (UTC-3), Chile (UTC-4), Colombia/Peru (UTC-5)
  // Highly variable - add specific airports!
  'S': 'America/Sao_Paulo',

  // Mexico and Central America
  'M': 'America/Mexico_City',

  // Caribbean (mostly UTC-4 to UTC-5)
  'T': 'America/Nassau',

  // Pacific: Alaska (UTC-9), Hawaii (UTC-10), Guam (UTC+10), etc.
  // Highly variable! Add specific airports.
  'P': 'Pacific/Honolulu',

  // Africa - various G prefixes (Morocco, Canary Islands, West Africa)
  'G': 'Africa/Casablanca',

  // Africa - D prefix (Nigeria, Tunisia, Algeria)
  'D': 'Africa/Lagos',

  // Africa - F prefix (Southern/Eastern Africa, Indian Ocean)
  'F': 'Africa/Johannesburg',
};

/**
 * Parse a date string as UTC. Database stores UTC without 'Z' suffix,
 * but JS treats ISO strings without 'Z' as local time. This appends 'Z'
 * to ensure correct UTC parsing.
 */
function parseAsUTC(date) {
  if (date instanceof Date) return date;
  if (typeof date === 'string' && date.includes('T') && !date.endsWith('Z') && !/[+-]\d{2}(:\d{2})?$/.test(date)) {
    return new Date(date + 'Z');
  }
  return new Date(date);
}

/**
 * Get timezone for an ICAO airport code
 * @param icao - ICAO airport code (e.g., 'KJFK')
 * @returns IANA timezone string (e.g., 'America/New_York')
 */
export function getAirportTimezone(icao) {
  if (!icao) return 'UTC';

  const code = icao.toUpperCase().trim();

  // Check exact match first
  if (AIRPORT_TIMEZONES[code]) {
    return AIRPORT_TIMEZONES[code];
  }

  // Try with K prefix for US 3-letter codes (e.g., TEB → KTEB)
  if (code.length === 3) {
    const withK = 'K' + code;
    if (AIRPORT_TIMEZONES[withK]) {
      return AIRPORT_TIMEZONES[withK];
    }
  }

  // Try regional fallback based on first letter
  const prefix = code.charAt(0);
  if (REGIONAL_FALLBACKS[prefix]) {
    return REGIONAL_FALLBACKS[prefix];
  }

  // Default to user's local timezone if airport unknown
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

/**
 * Format a date in an airport's local timezone
 * @param date - Date to format (string or Date object)
 * @param icao - ICAO airport code
 * @param options - Intl.DateTimeFormat options
 * @returns Formatted date string
 */
export function formatDateInAirportTimezone(date, icao, options = {}) {
  if (!date) return '';

  const dateObj = parseAsUTC(date);

  if (isNaN(dateObj.getTime())) return '';

  const tz = getAirportTimezone(icao);
  const defaultOptions = {
    day: 'numeric',
    month: 'short',
    timeZone: tz,
    ...options,
  };

  return new Intl.DateTimeFormat('en-US', defaultOptions).format(dateObj);
}

/**
 * Format time in an airport's local timezone
 * @param date - Date to format (string or Date object)
 * @param icao - ICAO airport code
 * @param options - Additional Intl.DateTimeFormat options
 * @returns Formatted time string (e.g., "14:30")
 */
export function formatTimeInAirportTimezone(date, icao, options = {}) {
  if (!date) return '';

  const dateObj = parseAsUTC(date);

  if (isNaN(dateObj.getTime())) return '';

  const tz = getAirportTimezone(icao);
  const defaultOptions = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: tz,
    ...options,
  };

  return new Intl.DateTimeFormat('en-US', defaultOptions).format(dateObj);
}

/**
 * Format date and time in an airport's local timezone
 * @param date - Date to format (string or Date object)
 * @param icao - ICAO airport code
 * @returns Object with formatted date and time
 */
export function formatDateTimeInAirportTimezone(date, icao) {
  return {
    date: formatDateInAirportTimezone(date, icao),
    time: formatTimeInAirportTimezone(date, icao),
  };
}

/**
 * Get timezone abbreviation for display (e.g., "EST", "PST")
 * @param date - Date (needed for DST calculation)
 * @param icao - ICAO airport code
 * @returns Timezone abbreviation
 */
export function getTimezoneAbbreviation(date, icao) {
  if (!date) return '';

  const dateObj = parseAsUTC(date);

  if (isNaN(dateObj.getTime())) return '';

  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZoneName: 'short',
  });

  const parts = formatter.formatToParts(dateObj);
  const tzPart = parts.find(part => part.type === 'timeZoneName');

  return tzPart ? tzPart.value : '';
}
